import { Flex, Grid, Text } from '@chakra-ui/react'

export function Caixas({ item, isEqual, calc }) {
    return (
        <Grid alignItems="center" fontSize="15px" ml="auto" gridTemplateColumns="220px 220px 180px 170px" gap={2} placeItems="end">
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Total de Caixas:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {calc?.value ? '1' : item.cubagem.dimensoes.qtdcaixa} UNIDADE
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Caixa Utilizada:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {calc?.value ? calc?.value : item.cubagem.dimensoes.caixa}
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Peso unitário:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {item.cubagem.unitario} kg
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Peso total:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {parseFloat(item?.cubagem?.total).toFixed(2)} kg
                </Text>
            </Flex>
        </Grid>

        //   <Grid
        //   maxW="1316px"
        //   gridTemplateColumns="repeat(2, 640px)"
        //   columnGap="35px"
        //   rowGap="23px"
        //   mx="auto"
        //   color="white"
        //   fontSize="15px"
        //   fontWeight="light"
        //   mt={6}>
        //   <GridItem colSpan="2">
        //     <Grid maxW="640px" gridTemplateColumns="repeat(2, 1fr)" gap="10px" color="black">
        //       <GridItem border="1px solid #378BBF" px={3} py={2}>
        //         <Text color="#378BBF" as="span" fontWeight="bold">
        //           CAIXA:
        //         </Text>{' '}
        //         {item.cubagem.dimensoes.caixa}{' '}
        //         <Text color="#378BBF" as="span" fontWeight="bold">
        //           QNT:
        //         </Text>{' '}
        //         {item.cubagem.dimensoes.qtdporcaixa} UNIDADE
        //       </GridItem>
        //       <GridItem border="1px solid #378BBF" px={3} py={2}>
        //         <Text color="#378BBF" as="span" fontWeight="bold">
        //           TOTAL DE CAIXAS:
        //         </Text>{' '}
        //         {item.cubagem.dimensoes.qtdcaixa} UNIDADE
        //       </GridItem>

        //       { calc?.value && (
        //         <GridItem
        //           border="1px solid #378BBF"
        //           px={3}
        //           py={2}
        //           colSpan={2}
        //           display="flex"
        //           justifyContent="space-between"
        //           alignItems="center">
        //           <Flex lignItems="center" justifyContent="space-between" gap={2} w="full">
        //             <Text color="#378BBF" as="span" fontWeight="bold">
        //               CAIXA AGRUPADA:
        //             </Text>{' '}
        //             {calc?.value}
        //           </Flex>
        //           <Flex lignItems="center" justifyContent="space-between" gap={2} w="full">
        //             <Text color="#378BBF" as="span" fontWeight="bold">
        //               QNT:
        //             </Text>{' '}
        //             1 UNIDADE
        //           </Flex>
        //         </GridItem>
        //       )}
        //     </Grid>
        //   </GridItem>
        //   <GridItem bgColor="#378BBF" py={1}>
        //     <Grid gridTemplateColumns="1fr 90px 90px 160px 60px" placeItems="center">
        //       <GridItem ml="18px" placeSelf="start">
        //         Transportadora
        //       </GridItem>
        //       <GridItem>Prazo</GridItem>
        //       <GridItem>Valor Real</GridItem>
        //       <GridItem>Valor + 30%</GridItem>
        //     </Grid>
        //   </GridItem>
        //   <GridItem bgColor="#378BBF" py={1}>
        //     <Grid gridTemplateColumns="1fr 90px 90px 160px 60px" placeItems="center">
        //       <GridItem ml="18px" placeSelf="start">
        //         Transportadora
        //       </GridItem>
        //       <GridItem>Prazo</GridItem>
        //       <GridItem>Valor Real</GridItem>
        //       <GridItem>Valor + 30%</GridItem>
        //     </Grid>
        //   </GridItem>
        // </Grid>
    )
}

export function Caixa({ item, calc }) {
    return (
        <Grid alignItems="center" fontSize="15px" ml="auto" gridTemplateColumns="220px 220px 180px 170px" gap={2} placeItems="end">
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Total de Caixas:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    1 UNIDADE
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Caixa Agrupada:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {calc?.value}
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Peso unitário:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {parseFloat(item.cubagem.dimensoes.pesocaixa).toFixed(2)} kg
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between" gap={2} w="full">
                <Text>Peso total:</Text>
                <Text bg="#378BBF" color="white" px={2}>
                    {parseFloat(item.cubagem.dimensoes.pesocaixa).toFixed(2)} kg
                </Text>
            </Flex>
        </Grid>
    )
}
